import { type FC } from 'react';
import { Provider } from 'react-redux';
import { type Store } from 'redux';
import { useLazyLoadQuery } from 'react-relay';
import { type Locale } from 'dibs-intl/exports/locales';
import { type DEVICE_TYPES } from 'dibs-buyer-layout/exports/deviceTypeEnums.ts';

import { IntlProvider } from 'dibs-react-intl';
import { DibsWeb3ReactProvider } from 'dibs-crypto-utils/exports/DibsWeb3ReactProvider.ts';

import { NftHeaderLayout } from '../nftHeader/NftHeaderLayout.tsx';
import { EXHIBITIONS } from '../nftHeader/pageType.ts';
import { NftExhibitionsLayout } from './NftExhibitionsLayout.tsx';
import {
    NftExhibitionsEntryQuery,
    type NftExhibitionsEntryQueryType,
} from './NftExhibitionsEntryQuery.ts';

type Props = {
    locale: Locale;
    deviceType: DEVICE_TYPES;
    store: Store;
};

export const NftExhibitionsWrapper: FC<Props> = ({ locale, deviceType, store }) => {
    const data = useLazyLoadQuery<NftExhibitionsEntryQueryType>(NftExhibitionsEntryQuery, {});

    return (
        <IntlProvider locale={locale} disableTranslations>
            <DibsWeb3ReactProvider>
                <Provider store={store}>
                    <NftHeaderLayout
                        viewer={data.viewer}
                        isNftLandingPage
                        serverDeviceType={deviceType}
                        initialPageType={EXHIBITIONS}
                    >
                        <NftExhibitionsLayout viewer={data.viewer} />
                    </NftHeaderLayout>
                </Provider>
            </DibsWeb3ReactProvider>
        </IntlProvider>
    );
};
